import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import app from './app';
import propertyType from './propertyType';
import lead from './lead';
import location from './location';
import hydration from './hydration';
import joinDetails from './joinDetails';
import google from './google';
import classification from './classification';
import eloqua from './eloqua';

const reducers = {
    app,
    propertyType,
    lead,
    location,
    hydration,
    joinDetails,
    google,
    classification,
    eloqua
};

// used client side, includes router reducer to support ConnectedRouter
export const createClientSideReducer = (history) => combineReducers({
    router: connectRouter(history),
    ...reducers
});

// used server side, no router reducer since we don't have a browser history object
export const createServerSideReducer = () => combineReducers(reducers);
